const tab_sections = {
    identity: 'Kimlik',
    integrations: 'Bağlantılar',
    login_security: 'Oturum açma ve güvenlik',
    permissions: 'İzinler',
    automation: 'Otomasyon',
    platform: 'Platform',
    overview: 'Genel Bakış',
    authentication: 'Kimlik doğrulama',
    authorization: 'Yetkilendirme',
    users: 'Kullanıcılar',
    developer: 'Geliştirici',
    tenant: 'Kiracı',
};
export default Object.freeze(tab_sections);
